import React from 'react'

export const InfoIcon = () => {
  return (
    <svg width="23" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.0469 10.624L14.0469 21.963" stroke="#868686" strokeWidth="2.19048" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.0469 5.92471L14.06 5.91016" stroke="#868686" strokeWidth="2.92063" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.0476 25.5073C20.7013 25.5073 26.0952 20.1134 26.0952 13.4597C26.0952 6.80601 20.7013 1.41211 14.0476 1.41211C7.3939 1.41211 2 6.80601 2 13.4597C2 20.1134 7.3939 25.5073 14.0476 25.5073Z" stroke="#868686" strokeWidth="2.19048" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
import React from 'react'

export const InfoIcon = () => {
  return (
    <svg width="23" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.0469 10.624L14.0469 21.963" stroke="#868686" strokeWidth="2.19048" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.0469 5.92471L14.06 5.91016" stroke="#868686" strokeWidth="2.92063" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.0476 25.5073C20.7013 25.5073 26.0952 20.1134 26.0952 13.4597C26.0952 6.80601 20.7013 1.41211 14.0476 1.41211C7.3939 1.41211 2 6.80601 2 13.4597C2 20.1134 7.3939 25.5073 14.0476 25.5073Z" stroke="#868686" strokeWidth="2.19048" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
